export const MERCARI_CONDITIONS = ["New", "Like new", "Good", "Fair", "Poor"];
